import { t } from "@lingui/macro";
import * as React from "react";
import { Path, G, Defs, ClipPath } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const ThunderIcon = (props: IconProps) => (
  <Icon viewBox="0 0 16 16" title={t`Thunder`} {...props}>
    <G clipPath="url(#a)">
      <Path
        stroke="currentColor"
        strokeLinecap="round"
        strokeWidth={1.5}
        d="M11.5 10c1.932 0 3.5-1.512 3.5-3.375S13.432 3.25 11.5 3.25c-.571 0-1.115.14-1.592.375C9.17 2.078 7.548 1 5.667 1 3.09 1 1 3.016 1 5.5c0 1.758 1.046 3.28 2.57 4.021"
        fill="none"
      />
      <Path
        stroke="currentColor"
        d="m5 11 3.571-5-.714 4.167L10 11l-4.286 5 1.429-4.167L5 11Z"
        fill="currentColor"
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h16v16H0z" />
      </ClipPath>
    </Defs>
  </Icon>
);
